"use client";

import { useEffect, useRef } from "react";

import {
  loadTrustBox,
  TRUSTPILOT_BUSINESS_UNIT_ID,
  TRUSTPILOT_LOCALE,
  TRUSTPILOT_REVIEWS_URL,
} from "@/utils/trustpilot";

export default function TrustPilotBadge({ theme = "dark", className }: { theme?: string; className?: string }) {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (widgetRef.current === null) {
      return;
    }
    return loadTrustBox(widgetRef.current);
  }, []);

  return (
    <>
      <div className={`trustpilot-badge ${className}`} suppressHydrationWarning={true}>
        <div
          ref={widgetRef}
          className="trustpilot-widget"
          suppressHydrationWarning={true}
          data-locale={TRUSTPILOT_LOCALE}
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id={TRUSTPILOT_BUSINESS_UNIT_ID}
          data-style-height="150px"
          data-style-width="100%"
          data-theme={theme}
        >
          <a href={TRUSTPILOT_REVIEWS_URL} target="_blank" rel="noreferrer">
            Trustpilot
          </a>
        </div>
      </div>
    </>
  );
}
